import { Box, Chip, Stack, Typography, useTheme } from '@mui/material';
import React, { FC } from 'react';
import { useApiQuery } from '../query/hooks';
import { graphql } from '../gql';
import { FormattedMessage } from 'react-intl';

const listTagsQuery = graphql(`
	query tagsSelect_listTags {
		listTag {
			id
			name
		}
	}
`);

type TagsSelectProps = Readonly<{
	value: readonly string[];
	onChange(newTags: readonly string[]): void;
	loading?: boolean;
	size: 'medium' | 'small';
}>;

export const TagsCheckList: FC<TagsSelectProps> = ({ value, onChange, loading, size }) => {
	const { data } = useApiQuery(listTagsQuery);
	const theme = useTheme();

	const tags = data?.listTag.map((tag) => tag) ?? [];

	const selectedTags = value.filter((id) => tags.some((o) => o.id === id));

	if (loading) {
		return (
			<Typography sx={{ color: theme.palette.secondary.main }}>
				<FormattedMessage id={'common.loading'} />
			</Typography>
		);
	}

	return (
		<Stack direction={'column'} gap={2}>
			{tags.length > 0 && (
				<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
					{tags.map((tag) => (
						<Chip
							key={tag.id}
							label={tag.name}
							variant={'outlined'}
							size={size}
							sx={{
								backgroundColor: theme.palette.secondary.lighter,
								borderColor: selectedTags.includes(tag.id) ? theme.palette.primary[400] : theme.palette.secondary[400],
								opacity: selectedTags.includes(tag.id) ? 1 : 0.5,
							}}
							onClick={() =>
								selectedTags.includes(tag.id)
									? onChange(selectedTags.filter((pId) => pId !== tag.id))
									: onChange(selectedTags.concat(tag.id))
							}
						/>
					))}
				</Box>
			)}
		</Stack>
	);
};
